/* eslint-disable no-unused-vars */
import Modal from "@material-ui/core/Modal";
import React, { Component } from "react";
import moment from "moment";
import styles from "../../../Pages/OptionsBoard/OptionsBoardStyles";
import Utils from "../../../utils/utils";
import { checkStatus, jsonify, parseJSON } from "./functions";
import premium from "./Volume.png";
import premiumMobile from "./Volume.png";
import { formatPercentFine } from "../../../utils/numberFormatFunc";
import { barDataFunc, chartDataFunc, chartOptionsFunc, chartOptionsMobileFunc } from "./constant";
import MobileOptionTrade from "./MobileOptionTrade";
import DesktopTable from "./DesktopTable";
import AdminAccessTable from "./AdminAccessTable";
import { BaseURL } from "../../../constants";

class VolumeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderBy: "",
      order: "",
      data: [],
      modalLoader: false,
      tableData: [],
      OiState: [],
      modalDetail3: [],
      modalDetail2: [],
      modalDetail: [],
      upperData: [],
    };
  }
  fetchOptionsDetail = (ticker, expiry, PC, strike, date) => {
    fetch(
      `${BaseURL}/api/optionsdetail?ticker=${ticker}&expiry=${expiry}&PC=${PC}&strike=${strike}&interval=${1}&date=${date}`
    )
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {
        let data = jsonify(response);
        if (!data) return;
        this.setState({ modalDetail: data });
      });

    fetch(`${BaseURL}/api/stockSeries?ticker=${ticker}&date=${date}`)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {
        let data3 = jsonify(response);
        if (!data3) return;
        this.setState({ modalDetail3: data3 });
      });
  };

  fetchTopData = (ticker, expiry, PC, strike, date) => {
    fetch(
      `${BaseURL}/api/oiuper?ticker=${ticker}&expiration=${expiry}&PC=${PC}&strike=${strike}&date=${date}`
    )
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {
        this.setState({ upperData: response[0] });
      });
  };

  componentDidMount() {
    const ticker = this.props.ticker;
    const date = this.props.selectedDate;
    const strike = this.props.modalRowData.strike;
    const puttCall = this.props.modalRowData.put_call;
    const expiration = this.props.expiration;
    this.fetchOptionsDetail(ticker, expiration, puttCall, strike, date);
    this.fetchTopData(ticker, expiration, puttCall, strike, date);
  }
  formatVolume = (volume) => {
    if (volume) {
      return volume.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return "0";
    }
  };
  sortData = (type) => {
    this.setState({ orderBy: type });
    const { orderBy, order } = this.state;
    const isAsc = orderBy === type && order === "asc";
    this.setState({ order: isAsc ? "desc" : "asc" });
  };

  formatComma = (trade) => {
    return trade ? trade.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0";
  };

  render() {
    const {
      isMobile,
      showModal,
      ticker,
      expiration,
      closeVolumeModal,
      modalDate,
      modalRowData,
    } = this.props;
    const { orderBy, order } = this.state;

    const accessLevel = "fullaccess";
    const localOD = this.state.modalDetail.slice().reverse();
    // const localOD2 = this.state.modalDetail2.slice().reverse();
    const localOD3 = this.state.modalDetail3;
    const timeline = Utils.generateTimeIntervalsUntil(9.5,16,1,localOD,"time");
    const timeline2 = Utils.generateBarchatData(9.5, 16, 10, localOD, "time");
    var lineLabels = [];
    // var lineData = [];
    var lineData2 = [];

    for (const [key, value] of Object.entries(timeline)) {
      lineLabels.push(value.time);
      // lineData.push(value.spot);
      lineData2.push(formatPercentFine(value.ivol));
    }

    var lineData = localOD3.map((opt) => opt.last);
    const barLabel = [];
    const barActualData = [];

    for (const [key, value] of Object.entries(timeline2)) {
      barLabel.push(value.time);
      barActualData.push(value.volume);
    }
    const chartData=chartDataFunc(lineLabels,isMobile,ticker,lineData,lineData2);
    const chartOptions=chartOptionsFunc(ticker, lineLabels);
    const chartOptionsMobile=chartOptionsMobileFunc(ticker,lineLabels);
const barData=barDataFunc(barLabel,barActualData);

    return (
      <div style={isMobile ? { width: "60%" } : { width: "400px" }}>
        <Modal
          aria-labelledby='simple-modal-title'
          aria-describedby='simple-modal-description'
          open={showModal}
          onClose={closeVolumeModal}>
          <div
            style={
              isMobile
                ? styles.boardModalContentMobile
                : styles.boardModalContent
            }>
            <div
              onClick={() => closeVolumeModal()}
              style={
                !isMobile
                  ? styles.modalCloseButton
                  : styles.modalCloseButtonMobile
              }>
              X
            </div>

            {!isMobile && (
              <div style={{ ...styles.boardModalData }}>
                <h2 style={{ marginBottom: 0, marginTop: 20 }}>
                  Options Trade
                </h2>
                <div style={{ color: "gray", marginBottom: "20px" }}>
                  {moment(modalDate).format("MMM DD YYYY")}
                </div>

              <DesktopTable ticker={ticker} expiration={expiration} modalRowData={modalRowData} upperData={this.state.upperData} />
              </div>
            )}
            {isMobile && (
           <MobileOptionTrade expiration={expiration} modalDate={modalDate} modalRowData={modalRowData} ticker={ticker} upperData={this.state.upperData} />
            )}
            {accessLevel === "halfaccess" ? (
              <div style={styles.premiumdiv}>
                {" "}
                <div>
                  <img
                    height='100%'
                    width='100%'
                    src={isMobile ? premiumMobile : premium} alt=" " />
                </div>
              </div>
            ) : <AdminAccessTable chartData={chartData} chartOptionsMobile={chartOptionsMobile} chartOptions={chartOptions} barData={barData} order={order} orderBy={orderBy} localOD={localOD} sortData={this.sortData} />}
          </div>
        </Modal>
      </div>
    );
  }
}

export default VolumeModal;



// WEBPACK FOOTER //
// ./src/components/Modals/VolumeModal/index.js